/**
Copyright (C) 2022 by SeQuenX  - All Rights Reserved
This file is part of the SeQuenX product development,
and is released under the "Commercial License Agreement".
You should have received a copy of the Commercial License Agreement license with
this file. If not, please write to: legal@sequenx.com, or visit www.sequenx.com
*/
import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const CompanyUpdatesCard = () => {
  const { t } = useTranslation();
  const updates = t("sequenxUpdates", {
    returnObjects: true,
  });

  const safeUpdates = Array.isArray(updates) ? updates : [];

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="bg-white rounded-2xl border shadow-sm p-6"
    >
      {/* Header */}
      <div className="flex items-center gap-2 mb-6">
        <span className="h-2 w-2 rounded-full bg-cyan-400" />
        <h3 className="text-lg font-semibold text-gray-900">
          {t("sequenxCompanyUpdateTitle")}
        </h3>
      </div>
      <div className="space-y-6">
        {safeUpdates.map((item, index) => (
          <div
            key={index}
            className="pb-4 border-b border-gray-200 last:border-b-0"
          >
            <div className="space-y-1">
              <p className="text-xs font-medium tracking-wider text-gray-400 uppercase">
                {item.month}
              </p>

              <p className="text-sm text-gray-700 leading-relaxed">
                {item.text}
              </p>
            </div>
          </div>
        ))}
      </div>
    </motion.div>
  );
};

export default CompanyUpdatesCard;
